import IconLabel, { type IconLabelProps } from './icon-label';

export type { IconLabelProps };
export default IconLabel;
